import BaseList from 'records/BaseList';
import { DesignItemMappings } from 'records/DesignItemMapping';

import {
  DESIGN_ITEM_MAPPINGS_UPDATE_SUCCESS,
  DESGIN_ITEM_RESET_STATE,
} from 'actions/designItemMappings';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: DesignItemMappings(),
});

const actionsMap = {
  [DESIGN_ITEM_MAPPINGS_UPDATE_SUCCESS]: (state, action) => {
    return state.merge({
      data: action.data,
    });
  },
  [DESGIN_ITEM_RESET_STATE]: () => {
    return initialState;
  },
};

export default function designItemMappings(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
